import { createSelector } from 'reselect'
import hasInfoCartSelect from 'modules/cart/redux/selectors/has-info'
import shouldShowMinimumToCheckOutCartSelect from 'modules/cart/redux/selectors/should-show-checkout-minimum'
import shouldVisuallyShowMinimumToCheckOutCartSelectUtil from 'modules/cart/redux/selectors/should-visually-show-checkout-minimum/utils'

const shouldVisuallyShowMinimumToCheckOutCartSelect = createSelector(
  shouldShowMinimumToCheckOutCartSelect,
  hasInfoCartSelect,
  (
    shouldShowMinimumToCheckOut,
    hasCartInfo
  ) => shouldVisuallyShowMinimumToCheckOutCartSelectUtil({
    shouldShowMinimumToCheckOut,
    hasCartInfo
  })
)

export default shouldVisuallyShowMinimumToCheckOutCartSelect
